import clsx from 'clsx';

import APModal from 'components/Modal/APModal';
import FormSelect from 'components/FormFields/FormSelect';
import InputField from 'components/FormFields/InputField';
import { MODAL_STEPS } from './LeadRecord.Documents';

const DocumentModal = ({
  open,
  onClose,
  modalStep,
  selectedFileType,
  selectedTemplate,
  fileName,
  identifier,
  error,
  isAutonumbering,
  filteredTemplates,
  orgId,
  types,
  onFileTypeSelect,
  onTemplateChange,
  onFileNameChange,
  onIdentifierChange,
  onNext,
  onBack,
  onAdd,
}) => {
  const getModalTitle = () => {
    if (modalStep === MODAL_STEPS.SELECT_FILE_TYPE) {
      return 'Select file to add.';
    }
    return `Add ${selectedFileType} details.`;
  };
  const isQuoteInvoice = ['quote', 'invoice'].includes(selectedFileType);
  const isFormNotValid = !selectedTemplate || !fileName || (isQuoteInvoice && !identifier);
  const isDocumentsOnly = types.length === 4;

  return (
    <APModal
      open={open}
      onClose={onClose}
      title={getModalTitle()}
      name="select-file"
      size={isDocumentsOnly ? 'narrow' : null}
      errorMsg={error}
      actions={modalStep === MODAL_STEPS.FILE_DETAILS ? (
        <>
          <button
            type="button"
            className="button button--cancel"
            onClick={onBack}
          >
            Back
          </button>
          <button
            type="button"
            className="button"
            onClick={onAdd}
            disabled={isFormNotValid && !error}
          >
            Add
          </button>
        </>
      ) : (
        <button
          type="button"
          className="button"
          onClick={onNext}
          disabled={!selectedFileType}
        >
          Next
        </button>
      )}
    >
      {modalStep === MODAL_STEPS.SELECT_FILE_TYPE && (
        <>
          <h6>SELECT A FILE TYPE</h6>
          <div className={clsx('files-list', isDocumentsOnly && 'documents')}>
            {types.map((type) => {
              return (
                <div
                  key={type.value}
                  className="file-type"
                >
                  <input
                    type="radio"
                    id={`file-type-${type.value}`}
                    name="file-type"
                    checked={selectedFileType === type.value}
                    onChange={() => {}}
                    value={type.value}
                  />
                  <label
                    htmlFor={`file-type-${type.value}`}
                    className="file-type__content"
                    onClick={() => onFileTypeSelect(type.value)}
                  >
                    <div className="file-type__icon">
                      <img
                        src={type.icon}
                        alt={type.name}
                      />
                    </div>
                    <div className="file-type__name">{type.name}</div>
                  </label>
                </div>
              );
            })}
          </div>
        </>
      )}

      {modalStep === MODAL_STEPS.FILE_DETAILS && (
        <>
          <FormSelect
            name="Select template"
            value={selectedTemplate}
            required
            onChange={onTemplateChange}
          >
            <option value="from_scratch">
              Start from scratch
            </option>
            {filteredTemplates.map((template) => (
              <option
                value={template.id}
                key={`template_${template.id}`}
              >
                {template.name}
              </option>
            ))}
            <option
              value="no_templates"
              hidden={filteredTemplates.length > 0}
            >
              Set up your templates in {' '}
              <a
                href={`/app/pro/${orgId}/settings/templates/${
                  isQuoteInvoice ? selectedFileType : 'document'
                }-templates`}
              >
                Business Settings
              </a> so you can skip starting from scratch.
            </option>
          </FormSelect>

          <InputField
            name="file_name"
            label="File Name"
            required
            value={fileName}
            onChange={onFileNameChange}
          />

          {isQuoteInvoice && (
            <InputField
              name="identifier"
              label={`${selectedFileType} number`}
              required
              value={identifier}
              onChange={onIdentifierChange}
              disabled={isAutonumbering}
            >
              <a
                href={`/app/pro/${orgId}/settings/templates/invoice-templates`}
              >
                {isAutonumbering ? 'Disable auto-numbering' : 'Enable auto-numbering'}
              </a>
            </InputField>
          )}
        </>
      )}
    </APModal>
  );
};

export default DocumentModal;
